import React from "react";
import "./icon-text.scss";

export const IconText = (props: IconTextType) => {
  return (
    <div className="icon-text">
      <div className="icon-text__icon">
        {props.icon}
      </div>
      <div className="icon-text__text">
        <h4>{props.text}</h4>
      </div>
    </div>
  );
};

export type IconTextType = {
  id: number | string;
  icon: JSX.Element;
  text: string;
  borderRadious: number;
};
